import { PeriodicTask } from '../types/PeriodicTask';
import { PeriodicTaskRead } from '../../../../../store/generated/admin/system-health';

export const calculateCrontabNextRun = (crontab: any): string => {
  try {
    const now = new Date();
    const { minute, hour, day_of_week, day_of_month, month_of_year } = crontab;

    const parseCronField = (field: string, min: number, max: number): number[] => {
      if (field === '*') {
        return Array.from({ length: max - min + 1 }, (_, i) => min + i);
      }
      return field.split(',').map(n => parseInt(n.trim()));
    };

    const minutes = parseCronField(minute, 0, 59);
    const hours = parseCronField(hour, 0, 23);
    const daysOfMonth = parseCronField(day_of_month, 1, 31);
    const months = parseCronField(month_of_year, 1, 12);
    const daysOfWeek = parseCronField(day_of_week, 0, 6);

    let nextRun = new Date(now);
    nextRun.setSeconds(0, 0);

    for (let dayOffset = 0; dayOffset < 365; dayOffset++) {
      const testDate = new Date(now);
      testDate.setDate(testDate.getDate() + dayOffset);

      const testMonth = testDate.getMonth() + 1;
      const testDayOfMonth = testDate.getDate();
      const testDayOfWeek = testDate.getDay();

      // Check if month matches
      if (!months.includes(testMonth)) continue;

      // Check if day of month matches (handle both day_of_month and day_of_week)
      const dayMatches =
        daysOfMonth.includes(testDayOfMonth) || daysOfWeek.includes(testDayOfWeek);
      if (!dayMatches) continue;

      // Find next hour and minute
      for (const testHour of hours) {
        for (const testMinute of minutes) {
          const candidateTime = new Date(testDate);
          candidateTime.setHours(testHour, testMinute, 0, 0);

          if (candidateTime > now) {
            return candidateTime.toLocaleString();
          }
        }
      }
    }

    return 'No upcoming runs';
  } catch (error) {
    console.error('Error calculating crontab next run:', error);
    return 'Error calculating';
  }
};

export const getNextRunTime = (task: PeriodicTask | PeriodicTaskRead): string => {
  try {
    if (!task || !task.enabled) {
      return 'Disabled';
    }

    if (task.interval) {
      const now = new Date();
      const interval = task.interval;
      const period = interval.period;
      const every = interval.every;

      let nextRun = new Date(now);

      switch (period) {
        case 'seconds':
          nextRun.setSeconds(nextRun.getSeconds() + every);
          break;
        case 'minutes':
          nextRun.setMinutes(nextRun.getMinutes() + every);
          break;
        case 'hours':
          nextRun.setHours(nextRun.getHours() + every);
          break;
        case 'days':
          nextRun.setDate(nextRun.getDate() + every);
          break;
        case 'weeks':
          nextRun.setDate(nextRun.getDate() + every * 7);
          break;
        default:
          return 'Unknown schedule';
      }

      return nextRun.toLocaleString();
    } else if (task.crontab) {
      return calculateCrontabNextRun(task.crontab);
    }

    return 'No schedule';
  } catch (error) {
    console.error('Error calculating next run time:', error);
    return 'Error';
  }
};
